module.exports = "<md-content flex style=background-color:transparent> <div layout=row layout-align=\"center center\"> <img src=" + require("/Users/yo/Documents/MAC_TOQIO/Documents/projects/thesafezone/thesafezone-fe/src/assets/icons/loading.svg") + " alt=\"Loading app...\"> </div> </md-content> ";


//////////////////
// WEBPACK FOOTER
// ./src/containers/verify-account/verify-account.html
// module id = 168
// module chunks = 1